<div class="guid-picker-bar">
  <button mat-stroked-button color="primary" type="button" (click)="openPicker()">Pick GUID</button>
  <span class="guid-picker-hint" *ngIf="fieldHint">{{fieldHint}}</span>
</div>
